import React from "react";
import "./circle.scss";

const Circle = () => {
  return (
    <>
      <div className="stormouter_layer-circle">
        <section ion className="main-storm">
          <video
            className="main-banner-video"
            muted="muted"
            playsinline="playsinline"
            autoPlay
            loop
            width="100%"
            id="myVideo"
          >
            <source
              src="https://res.cloudinary.com/drt6vurtt/video/upload/v1736357338/rain-prediction/joinvideo_o0v9oi.mov"
              type="video/mp4"
            />
          </video>
          <svg
            className="circle_shade"
            xmlns="http://www.w3.org/2000/svg"
            width="1420"
            height="561"
            viewBox="0 0 1420 561"
            fill="none"
          >
            <g filter="url(#filter0_f_1957_1199)">
              <path
                d="M-143.037 624.84V20L-72.2945 94.8069C352.31 543.805 1066.9 544.018 1491.77 95.2728L1563.04 20V624.84H-143.037Z"
                fill="url(#paint0_linear_1957_1199)"
              />
              <path
                d="M-143.037 624.84V20L-72.2945 94.8069C352.31 543.805 1066.9 544.018 1491.77 95.2728L1563.04 20V624.84H-143.037Z"
                stroke="black"
                stroke-width="0.438321"
              />
            </g>
            <defs>
              <filter
                id="filter0_f_1957_1199"
                x="-362.417"
                y="-199.711"
                width="2144.83"
                height="1043.93"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="109.58"
                  result="effect1_foregroundBlur_1957_1199"
                />
              </filter>
              <linearGradient
                id="paint0_linear_1957_1199"
                x1="710"
                y1="20"
                x2="710"
                y2="648.941"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.6" stop-color="#D9FF00" />
                <stop offset="0.8" stop-color="#F3FF80" />
                <stop offset="1" stop-color="white" />
              </linearGradient>
            </defs>
          </svg>
          <svg className="phonesvg" xmlns="http://www.w3.org/2000/svg" width="420" height="625" viewBox="0 0 420 625" fill="none">
  <g filter="url(#filter0_f_1957_1219)">
    <path d="M-643.037 624.84V20L-572.295 94.8069C-147.69 543.805 566.897 544.018 991.769 95.2728L1063.04 20V624.84H-643.037Z" fill="url(#paint0_linear_1957_1219)"/>
    <path d="M-643.037 624.84V20L-572.295 94.8069C-147.69 543.805 566.897 544.018 991.769 95.2728L1063.04 20V624.84H-643.037Z" stroke="black" stroke-width="0.438321"/>
  </g>
  <defs>
    <filter id="filter0_f_1957_1219" x="-862.417" y="-199.711" width="2144.83" height="1043.93" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="109.58" result="effect1_foregroundBlur_1957_1219"/>
    </filter>
    <linearGradient id="paint0_linear_1957_1219" x1="210" y1="20" x2="210" y2="648.941" gradientUnits="userSpaceOnUse">
      <stop offset="0.6" stop-color="#D9FF00"/>
      <stop offset="0.8" stop-color="#F3FF80"/>
      <stop offset="1" stop-color="white"/>
    </linearGradient>
  </defs>
</svg>
          <div className="custom-containerr">
            <div className="inner-storm">
              <div className="leftsidestormtop">
                <h3>RAIN</h3>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="34"
                  viewBox="0 0 35 34"
                  fill="none"
                >
                  <path
                    d="M17.3401 0C18.1574 12.5011 32.2335 10.8766 32.2335 16.4536C32.2335 21.0003 25.5471 23.4372 17.2956 23.4372C9.04401 23.4372 2.35758 21.0003 2.35758 16.4536C2.35263 10.8766 16.4288 12.5011 17.251 0C7.71663 0.0247645 0 7.4046 0 16.513C0 25.6214 7.74139 33.026 17.2956 33.026C26.8497 33.026 34.5911 25.6313 34.5911 16.513C34.5911 7.39469 26.8695 0.0247645 17.3401 0Z"
                    fill="#727272"
                  />
                </svg>
                <h3>2026</h3>
              </div>
              <div className="storm-outter">
                <div className="leftsidestorm">
                  <div className="innnerchikd">
                    <h2>Stay ahead of the storm.</h2>
                    <p>
                      Join our dedicated channels for real-time release notes,
                      technical updates, and direct access to the protocol's
                      developer ecosystem.{" "}
                    </p>
                    <div className="bothbuttonns">
                      <a href="https://x.com/Rain_Builders" target="_Blank">
                        <button className="apply">
                          Follow Rain Builders on X
                        </button>
                      </a>
                      <a href="https://t.me/RainBuilders" target="_blank">
                        <button className="explore">
                          Join Rain Builders TG
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Circle;
